import { CanActivateFn, Router } from '@angular/router';
import { SupabaseService } from '../service/supabase.service';
import { inject } from '@angular/core';

export const CompanyUserGuard: CanActivateFn = async (route, state) => {
  
  console.log("User gaurd called");
  
  const supabaseService = inject(SupabaseService);
  const router = inject(Router);

  const currentCompanyUser = await supabaseService.getAllUserCompany();
  //This is when onboard router hit and no company user
  if(currentCompanyUser === 'error' && state.url.includes('/onboard')) return true
  //This is when choose company hit with company user and without company user we redirect to onboard
  if(currentCompanyUser !== 'error' && state.url.includes('/choose_company')) return true
  if(currentCompanyUser === 'error' && state.url.includes('/choose_company')) {
    router.navigate(['/onboard'])
    return false
  }

  return false
};
